import { createFileRoute, redirect } from "@tanstack/react-router";

/** Seit dem Rundgang vom 12.09.2026 ist das Angebotsarchiv eine Ansicht der Anfragen — alte Links laufen weiter. */
export const Route = createFileRoute("/_angemeldet/_mitarbeiter/angebote")({
	beforeLoad: () => {
		throw redirect({ to: "/anfragen", search: { ansicht: "angebote" }, replace: true });
	},
});
